var interval = null;

$(document).ready(function() {
  interval = setInterval(checkDocumentStatus, 5000);
});

function checkDocumentStatus() {
  var documents = document.querySelectorAll(".document_status[data-status='received']");

  if(documents.length === 0) {
    return clearInterval(interval);
  }

  for(var i = 0; i < documents.length; i++) {
    var documentId = documents[i].dataset.id;

    $.ajax({
      url: "/mon-compte/document_status/" + documentId,
      type: "GET",
      success: function(data) {
        var statusDoc     = document.getElementById("statusDoc" + data["id"]);
        var statusText    = document.getElementById("statusText" + data["id"]);
        var statusSpinner = document.getElementById("statusSpinner" + data["id"]);

        statusDoc.dataset.status = data["status"];
        statusDoc.className      = statusDoc.className.replace(/(^|\s)bg-\S+/g, " " + data["color"]);
        statusText.textContent   = data["status_text"];

        if(data["status"] === "received") {
          statusSpinner.classList.remove("d-none");
        } else {
          statusSpinner.classList.add("d-none");
        }
      }
    });
  };
}
